export default __webpack_public_path__ + "static/media/double_bg.efe519cb.jpg";